import { Flex } from '@chakra-ui/react';
import React from 'react';

import Button from 'components/Button';
import Drawer from 'components/Drawer';
import { RouteTabs, TabHeader, TabPanels } from 'components/Tabs';
import CategoryForm from 'containers/CompanySettings/TimeOffSetup/RightDrawer/CategoryForm';
import HolidayForm from 'containers/CompanySettings/TimeOffSetup/RightDrawer/HolidayForm';
import { useParamsQuery } from 'hooks/common/useParamsQuery';

import Categories from './Categories';
import Holidays from './Holidays';
import ImportHoliday from '../RightDrawer/ImportHoliday';

const TIMEOFF_TAB_NAME = {
  categories: 'categories',
  holidays: 'holidays',
};

const TimeOffSetupTabs: React.FC<unknown> = () => {
  const tabHeaders = [
    { label: 'Time Off Categories', tabName: TIMEOFF_TAB_NAME.categories },
    {
      label: 'Holidays',
      tabName: TIMEOFF_TAB_NAME.holidays,
    },
  ];

  const tabPanels = [{ panel: <Categories /> }, { panel: <Holidays /> }];

  const searchQuery = useParamsQuery();
  const activeTab = searchQuery.get('tab');

  return (
    <RouteTabs tabHeaders={tabHeaders}>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }}>
        <TabHeader tabHeaders={tabHeaders} />
        {activeTab === TIMEOFF_TAB_NAME.categories ? (
          <Drawer
            size="lg"
            drawerTrigger={onOpen => (
              <Button colorScheme="secondary" mt={{ base: '5', md: '0' }} onClick={onOpen}>
                Create Time Off Category
              </Button>
            )}
          >
            {onClose => <CategoryForm onClose={onClose} />}
          </Drawer>
        ) : (
          <Flex gridGap="3">
            <Drawer
              drawerTrigger={onOpen => (
                <Button colorScheme="secondary" mt={{ base: '5', md: '0' }} onClick={onOpen}>
                  Create Holiday
                </Button>
              )}
            >
              {onClose => <HolidayForm onClose={onClose} />}
            </Drawer>
            <Drawer
              drawerTrigger={onOpen => (
                <Button variant="secondary-ghost" mt={{ base: '5', md: '0' }} onClick={onOpen}>
                  Import Holidays
                </Button>
              )}
            >
              {onClose => <ImportHoliday onClose={onClose} />}
            </Drawer>
          </Flex>
        )}
      </Flex>
      <TabPanels tabPanels={tabPanels} />
    </RouteTabs>
  );
};
export default TimeOffSetupTabs;
